import script from "./AnaliticsCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnaliticsCell.vue?vue&type=script&lang=ts&setup=true"

import "./AnaliticsCell.vue?vue&type=style&index=0&id=1592a003&lang=sass"

const __exports__ = script;

export default __exports__